<template>
    <SuperAdminUsers v-if="isSuperAdmin" />
    <DashboardWeflix v-else>
        <Users />
    </DashboardWeflix>
</template>

<script>
import SuperAdminUsers from '@/Views/Weflix/SuperAdminUsers.vue';
import DashboardWeflix from '@/Views/Weflix/Adm/Dashboard.vue';
import Users from '@/Views/Weflix/Adm/Users.vue';

export default {
    name: 'AdminUsersEntry',
    components: {
        SuperAdminUsers,
        DashboardWeflix,
        Users,
    },
    computed: {
        isSuperAdmin() {
            return this.$store.state.userSuperAdmin != null && this.$store.state.token != null;
        },
    },
};
</script>
